import API from "@utils/plugins/API";

const FishingZoneService = {
  all: (params) => {
    return API.get("fishing-zones", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("fishing-zones", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`fishing-zones/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`fishing-zones/${id}`);
  },
  destroy: (id) => {
    return API.delete(`fishing-zones/${id}`);
  },
};

export default FishingZoneService;
